// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DocumentTypeDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class DocumentTypeApiClient extends BaseCRUDApiClient<DocumentTypeDto> {
  baseUrl = this.config.apiEndpoint + '/document-type';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
